import { Routes,Route } from 'react-router-dom';
import './App.css';
import Portfolio from "./portfolio.js";
import Projects from './projects.js';


export default function App () {
  return (
    <div className="App">
      <Routes>
        <Route path='/' element={<Portfolio/>}/>
        <Route path='/projects' element={<Projects/>}/>
      </Routes>
    </div>
  );
}

